import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';

import { routeTree } from './routeTree.gen';
import { createAppRouter } from './router';
import { providerQueryClient } from './services/apiClient';
import { initSentry } from './services/sentry';
import { initAnalytics, onRouteResolved } from './services/analytics';

initSentry();
initAnalytics();

const router = createAppRouter(routeTree);
router.subscribe('onResolved', onRouteResolved);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    from?: string;
  }
}

const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <QueryClientProvider client={providerQueryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
